var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSquareGrid2X2Fill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 8,
  x: 1,
  y: 1,
  fill: "currentColor",
  rx: 2
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 8,
  x: 11,
  y: 1,
  fill: "currentColor",
  rx: 2
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 8,
  x: 1,
  y: 11,
  fill: "currentColor",
  rx: 2
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 8,
  x: 11,
  y: 11,
  fill: "currentColor",
  rx: 2
})));
export default SvgSquareGrid2X2Fill;